import type { components } from '@joyful/openapi/types.gen'
import { createContext, use } from 'react'
export type ActiveAccountContextValue =
  | components['schemas']['CurrentUserAccountRead']
  | null

export const ActiveAccountContext =
  createContext<ActiveAccountContextValue>(null)

export function useActiveAccount() {
  return use(ActiveAccountContext)
}
